var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.distribution.permission
    ? _c("div", { staticClass: "well" }, [
        _c("i", {
          staticClass: "fas fa-caret-square-down",
          attrs: { title: "Expand elements" },
          on: {
            click: function ($event) {
              return _vm.expand()
            },
          },
        }),
        _vm._v(" "),
        _c(
          "a",
          {
            on: {
              click: function ($event) {
                return _vm.expand()
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.distribution.name) + " ")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "pull-right",
            attrs: {
              href: _vm.objectUrl + _vm.distribution.id,
              target: "_blank",
            },
          },
          [
            _c("i", {
              staticClass: "fal fa-external-link",
              attrs: { title: "Open distribution in new tab" },
            }),
          ]
        ),
        _vm._v(" "),
        _c("p", {
          domProps: { innerHTML: _vm._s(_vm.distribution.definition) },
        }),
        _vm._v(" "),
        _vm.isExpanded
          ? _c(
              "div",
              [
                _c("distribution-data-element-path", {
                  attrs: { distribution: _vm.distribution },
                }),
              ],
              1
            )
          : _vm._e(),
      ])
    : _c("div", { staticClass: "well" }, [_vm._m(0)])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("em", [
        _vm._v("You do not have permission to view this distribution"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }